import {
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useState, useEffect } from "react";
import { HIDE_TOOL_SMALL_SCREEN, TOAST_TYPE, VIEWPORT_TOOLS } from "../../../../../constants/Constants";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { Enums, annotation } from "@cornerstonejs/tools";
import { eventTarget } from "@cornerstonejs/core";
import {
  enableVOISync,
  FlipHorizontally,
  FlipVertically,
  getViewport,
  loadMPR,
  originalResolution,
  reset,
  resizeViewport,
  setInvert,
  setRotation,
} from "../../../helpers/CornerstoneViewportService";
import GetToolSVG from "./GetToolSVG";
import WindowLevelToolComponent from "./WindowLevelToolComponent";
import Viewport from "../../Viewport/Viewport";
import { useTranslation } from "react-i18next";
import {
  createSeriesData,
  isReconstructable,
} from "../../../helpers/MPRService";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import toastContext from "../../../../../context/toast/ToastContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import { isMobile } from "react-device-detect";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import StackScrollToolComponent from "./StackScrollToolComponent";
import ZoomToolComponent from "./ZoomToolComponent";
import { toolStyle, toolTipStyles } from "../../../styles/styles";
import {
  disableStackScrollSync,
  enableStackScrollSync,
} from "../../../helpers/StackScrollSyncService";
import { logAmplitudeEventWithUsernameAndRole } from "../../../../../helpers/Amplitude";
import userContext from "../../../../../context/users/UserContext";
import $ from "jquery";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const Tool = ({ tool }) => {
  const { showToastv2 } = useContext(toastContext);
  const [hovered, setHovered] = useState(false);
  const [cineState, setCineState] = useState(false);
  const {
    activeTool,
    setActiveTool,
    previousActiveTool,
    setPreviousActiveTool,
    activeViewportIndex,
    annotationDataAI,
    addedAnnotation,
    boundingBox,
    setIsCineEnabled,
    isCineEnabled,
    setIsSynchronizedEnabled,
    isSynchronizedEnabled,
    setIsMPRActive,
    isMPRActive,
    viewportElements,
    viewportSeriesData,
    mprLoading,
    setMprLoading,
    activeMPRTool,
    setActiveMPRTool,
    activeMPRViewportIndex,
    setIsCompareActive,
    isCompareActive,
    viewportRow,
    viewportColumn,
    changeLayout,
    setMprViewportElements,
    setIsMPRViewportActivated,
    setMPRViewportLoaderRunning,
    setVolumeId,
    handleDefaultToolChange,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable,
    setIsCropEnable
  } = useContext(ViewportContext);

  const { setActiveMPRThumbnailIndex, activeThumbnailIndex } =
    useContext(ThumbnailContext);

  const { ref, setLoaderRunning } = useContext(loaderContext);

  const { setProgressComplete, setProgress, setShowToast } =
    useContext(studyviewerContext);

  const { username } = useContext(userContext);

  const { t } = useTranslation();

  const [toolTipId, setToolTipId] = useState(t(tool.name));

  const changeActiveTool = async (tool) => {
    // eventTarget.reset();
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    
    if (!isBBMode && !isCropMode && activeTool === tool.key) {
      setPreviousActiveTool(activeTool);
      // setActiveTool(StackScrollTool.toolName);
      handleDefaultToolChange();
    } else {
      setPreviousActiveTool(activeTool);
      setActiveTool(tool.key);
      if (tool.isEvent) {
        logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
      }
    }
  };

  const toggleMPR = async (tool) => {
    setMPRViewportLoaderRunning(true);

    const isSeriesReconstructable = await isReconstructable(
      activeViewportIndex,
      "viewport",
      setProgress
    );

    if (!isSeriesReconstructable.value) {
      setMPRViewportLoaderRunning(false)
      showToastv2(TOAST_TYPE.ERROR, t("mpr.not-reconstructable"));
      return;
    }
    setActiveMPRTool(WindowLevelTool.toolName);
    setActiveMPRThumbnailIndex(activeThumbnailIndex);
    setIsMPRActive(!isMPRActive);
    setTimeout(async () => {
      await loadMPR(
        activeViewportIndex,
        "viewport",
        viewportSeriesData[activeViewportIndex].series,
        setMprLoading,
        setMprViewportElements,
        setIsMPRViewportActivated,
        setVolumeId
      );
      // setMPRViewportLoaderRunning(false)
    }, 1500);
    enableVOISync();
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleCompareClick = async () => {
    if (viewportRow === 1 && viewportColumn === 1 && !isCompareActive) {
      changeLayout(1, 2);
    }
    setIsCompareActive(!isCompareActive);
  };

  const handleViewportClickTool = async (tool) => {
    switch (tool.key) {
      case "Invert":
        await setInvert(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateRight":
        await setRotation(activeViewportIndex, 90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "RotateLeft":
        await setRotation(activeViewportIndex, -90);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipVertical":
        await FlipVertically(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "FlipHorizontal":
        await FlipHorizontally(activeViewportIndex);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Reset":
        await reset(activeViewportIndex, boundingBox, annotationDataAI, addedAnnotation);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "CINE":
        setIsCineEnabled(!isCineEnabled);
        if (tool.isEvent) {
          logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
        }
        break;
      case "Synchronize":
        if (!isSynchronizedEnabled) {
          enableStackScrollSync(activeViewportIndex);
          if (tool.isEvent) {
            logAmplitudeEventWithUsernameAndRole(tool.eventName, {}, username);
          }
        } else {
          disableStackScrollSync();
        }
        setIsSynchronizedEnabled(!isSynchronizedEnabled);
        break;
      default:
        break;
    }
    const viewportContainer = $(`#viewport-box-${activeViewportIndex}`);
    viewportContainer.addClass("blinking");
    setTimeout(() => {
      viewportContainer.removeClass("blinking");
    },1000)
  };

  if (tool.key === WindowLevelTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <WindowLevelToolComponent
            toolName={tool.key}
            hovered={hovered}
            tool={tool}
          />
        </div>
      </>
    );
  }

  if (tool.key === StackScrollTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <StackScrollToolComponent tool={tool} />
        </div>
      </>
    );
  }

  if (tool.key === ZoomTool.toolName) {
    return (
      <>
        <div style={toolStyle}>
          <ZoomToolComponent tool={tool} />
        </div>
      </>
    );
  }

  if (tool.key === "MPR") {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={toolTipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={isMobile ? "" : toolTipId}
        >
          <div
            onClick={() => toggleMPR(tool.key)}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={{ ...toolStyle, margin: "0 0 0 10px" }}
            aria-describedby={toolTipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "#FFFFFF",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <GetToolSVG toolName={tool.key} hovered={hovered} />
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }

  if (tool.key === "Compare") {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={toolTipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={isMobile ? "" : toolTipId}
        >
          <div
            onClick={handleCompareClick}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={{ ...toolStyle, margin: "0 10px 0 0" }}
            aria-describedby={toolTipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "#FFFFFF",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <GetToolSVG toolName={tool.key} hovered={hovered} />
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }

  if (!VIEWPORT_TOOLS.includes(tool.key)) {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={toolTipId}
          directionalHint={DirectionalHint.bottom}
          styles={toolTipStyles}
          content={isMobile ? "" : toolTipId}
        >
          <div
            onClick={() => changeActiveTool(tool)}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={toolStyle}
            className={`${HIDE_TOOL_SMALL_SCREEN.includes(tool.key)?"hide-tool":""}`}
            aria-describedby={toolTipId}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={
                      isMobile ? "highlight-tool-mobile" : "highlight-tool"
                    }
                  >
                    <GetToolSVG toolName={tool.key} hovered={hovered} />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    // color: "#FFFFFF",
                    color: "var(--mobile-color-txt)",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <div className="highlight-tool">
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  } else {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={toolTipId}
          directionalHint={DirectionalHint.bottomCenter}
          styles={toolTipStyles}
          content={isMobile ? "" : toolTipId}
        >
          <div
            onClick={() => {
              handleViewportClickTool(tool);
            }}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseLeave}
            style={toolStyle}
            aria-describedby={toolTipId}
            className={`${HIDE_TOOL_SMALL_SCREEN.includes(tool.key)?"hide-tool":""}`}
          >
            {isMobile ? (
              <>
                <div
                  style={{
                    height: "65%",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={
                      isMobile ? "highlight-tool-mobile" : "highlight-tool"
                    }
                  >
                    <GetToolSVG toolName={tool.key} hovered={hovered} />
                  </div>
                </div>
                <span
                  style={{
                    fontSize: "9px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    //color: "#FFFFFF",
                    //color: "var(--navbar-header-popup-color-txt)",
                    color: "var(--mobile-color-txt)",
                  }}
                >
                  {t(tool.name)}
                </span>
              </>
            ) : (
              <>
                <div className="highlight-tool">
                  <GetToolSVG toolName={tool.key} hovered={hovered} />
                </div>
              </>
            )}
          </div>
        </CustomToolTipHost>
      </>
    );
  }
};

export default Tool;
